<script setup>
defineProps({
  rowReverse: {
    type: Boolean,
    default: false,
  },
  title: {
    type: [Object, String],
    required: true,
    text: {
      type: String,
    },
    color: {
      type: String,
    },
  },
  description: {
    type: String,
    default: "",
  },
  value: {
    type: [Object, String, Number],
    required: true,
    text: {
      type: [String, Number],
    },
    color: {
      type: String,
    },
  },
  percentage: {
    type: [Object, String],
    value: {
      type: String,
    },
    color: {
      type: String,
    },
    default: () => ({
      color: "success",
    }),
  },
  icon: {
    type: [String, Object],
    component: {
      type: String,
    },
    background: {
      type: String,
    },
    shape: {
      type: String,
    },
    default: () => ({
      background: "bg-white",
      shape: " border-radius-md",
    }),
  },
  classContent: {
    type: String,
    default: "",
  },
});
</script>
<template>
  <div class="mb-3 card">
    <div class="p-1 p-lg-3 card-body">
      <div class="d-flex">
        <!-- Avatar - Small on mobile, original on desktop -->
        <div class="avatar text-dark d-flex justify-content-center align-items-center mx-1 me-2 me-lg-3"
             :class="[
               typeof icon === 'object' 
                 ? `${icon.background} ${icon.shape}`
                 : 'border-radius-md',
               rowReverse ? 'me-2' : '',
               'mobile-sm-avatar'  // New class for mobile sizing
             ]">
          <i class="fas fa-check-circle" 
             :class="[
               typeof icon === 'string' ? icon : icon.component,
               'fa-sm',  // Small on mobile
               'fa-lg-lg'  // Will override to large on desktop
             ]"></i>
        </div>

        <div :class="classContent">
          <div class="numbers">
            <p class="mb-0 text-xs text-lg-sm text-uppercase font-weight-bold mt-1" 
               :class="title.color">
              {{ typeof title === "string" ? title : title.text }}
            </p>
            <h5 :class="`mb-0 font-weight-bolder responsive-heading ${value.color}`">
              {{ (value && typeof value === "string") || (value && typeof value === "number") ? value : value.text }}        
            </h5>
            <p v-if="description" class="mt-2 mb-0" v-html="description"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@media (max-width: 768px) {
  .responsive-heading {
    font-size: 0.875rem !important;
  }
}
@media (max-width: 991.98px) {
  .mobile-sm-avatar {
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
  }
  
  .fa-lg-lg {
    font-size: 1em !important; /* Default/small size on mobile */
  }
}

/* Desktop styles (applies to screens ≥ 992px) */
@media (min-width: 992px) {
  .mobile-sm-avatar {
    /* Original avatar size will apply */
  }
  
  .fa-lg-lg {
    font-size: 1.33em !important; /* Original large size */
    line-height: 0.75em !important;
    vertical-align: -0.0667em !important;
  }
}
</style>